import Helper from '@ember/component/helper';
import { PLATFORM_ICONS } from 'cio/utils/push/platforms';

export function pushPlatformIconClass([platform]) {
  return PLATFORM_ICONS[platform];
}

export default Helper.helper(pushPlatformIconClass);
